import React, { createContext, useState, useContext, useEffect } from "react";
import * as api from "../api/api";

// Create a context
const UserCacheContext = createContext();

// Create a provider component
export const UserCacheProvider = ({ children }) => {
  const [userCache, setUserCache] = useState({});
  const [fetchedAll, setFetchedAll] = useState(false);

  const setUser = (id, user) => {
    setUserCache((prevCache) => ({
      ...prevCache,
      [id]: user,
    }));
  };

  const getUser = async (id) => {
    if (!userCache[id]) {
      try {
        const response = await api.getUserById(id);
        const user = response.data.object;
        setUser(id, user);
        return user;
      } catch (error) {
        console.error("Error fetching user:", error);
        throw error;
      }
    } else {
      return userCache[id]; // Return cached user if already exists
    }
  };

  const getAllUsers = async () => {
    if (!fetchedAll) {
      try {
        const response = await api.getAllUsers();
        const users = response.data.object;
        users.forEach((user) => {
          setUser(user.id, user);
        });
      } catch (error) {
        console.error("Error fetching all users:", error);
        throw error;
      }
    } else {
      // return user cache as an array of objects
      return Object.values(userCache);
    }
  };

  const setAllUsers = async (users) => {
    // receive all users
    users.forEach((user) => {
      setUser(user.id, user);
    });
    setFetchedAll(true);
  };

  return (
    <UserCacheContext.Provider
      value={{ userCache, setUser, getUser, getAllUsers, setAllUsers }}
    >
      {children}
    </UserCacheContext.Provider>
  );
};

// Custom hook to use the user cache
export const useUserCache = () => {
  return useContext(UserCacheContext);
};
